import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ReportHistoryModule } from './components/report-history/report-history.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        ReportHistoryModule
    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        ReportHistoryModule
    ]
})
export class SharedModule
{
}
